import Numeral from "numeral";
import { format } from 'date-fns'

/**
 * Getting value from a data object by path
 * @param  {String} value The data object
 * @param  {String} format The path
 * @return {Mixed}  The value
 */
export const formatNumber_util = (value, pattern) => {
    return (
        Numeral(value).format(pattern)
    )
}

/**
 * Getting value from a data object by path
 * @param  {String} value The data object
 * @param  {String} format The path
 * @return {Mixed}  The value
 */
export const formatMoney_util = (value, pattern) => {
    return (
        Numeral(value).format(pattern)
    )
}

/**
 * Getting value from a data object by path
 * @param  {String} pre The path
 * @return {Mixed}  The value
 */
export const generateKey_util = (pre) => {
    return `${pre}_${new Date().getTime()}`;
}



/**
 * Getting value from a data object by path
 * @param  {String} pre The path
 * @return {Mixed}  The value
 */
export const generateQueryParam_util = (obj) => {
    return Object.keys(obj).map((key) => {
        //Getting input variable
        let param = obj[key];
        //If the type of data is a string
        if (typeof param == 'string'){
            param = param.trim();
        };
        //Return 
        return (encodeURIComponent(key) + '=' + encodeURIComponent(param));
    }).join('&');
}



/**
 * Checking empty {} [] '' undefined null NaN
 * @param  {String} field, The string value
 * @return {bool}  The value
 */
export const isEmpty_util = (value) => {//value === NaN ||. 
    try {
        return value === undefined ||
            value === null ||
            (typeof value === "object" && Object.keys(value).length === 0) ||
            (typeof value === "string" && value.trim().length === 0)
    } catch (e) {
        console.error(e)
    }
};


/**
 * Highlight Text
 * @param  {String} event, The string value
 */
export const highlightText_util = (event) => {
    event.target.select();
};


/**
 * Get Pagination Offset
 * @param  {String} event, The string value
 */
export const getPaginationOffset_util = (activePage, limit) => {
    return  ((parseInt(activePage) * limit) - limit);
};


/**
 * Get Record List Number
 * @param  {String} event, The string value
 */
export const getPaginationNumbering_util = (activePage, limit, index) => {
    return  (parseInt(activePage) * limit) - (limit - (index + 1));
};



/**
 * Check if a string is empty
 * @param  {String} string, The string to search from
 * @param  {String} pattern, The pattern to search for
 * @param  {String} level, The string value
 * 
 * @return  {bool} true/ false,
 */
export const search_util = (string, pattern, level = "STRICT") => {
    let case_sensitivity = (level !== "STRICT") ? 'g' : 'i';
    let stringValue = (string !== null) ? string : '';
    if (stringValue.search(new RegExp(pattern, case_sensitivity)) > -1) {
        return true;
    };
    return false;
};




/**
 * Getting the value of a select input field
 * @param  {String} field, The string value
 * @param  {String} field, The string value
 * @return {bool}  The value
 */
export const getSelected_util = (arr, key = 'value', value) => {
    return (isEmpty_util(value)) ? '' : arr.find(element => element[key] === value);
}


/**
 * Checkbox filtering
 * @param  {array} arrayOfObject, The arrayOfObject value
 * @param  {string} key, The id values to return
 * @return {array}  The value
 */
export const checkedItemId_util = (arrayOfObject, key = 'rowId') => {
    const filtered = [];
    if (Array.isArray(arrayOfObject)) {
        arrayOfObject.forEach((obj) => {
            if (obj.checked) {
                filtered.push(obj[key])
            }
        });
    }
    return filtered;
}




/**
 * It is used to generate form data expecially with an image to send to database 
 * @param  {String} imageKey, The formik data object image key
 * @param  {String} imageFile, The image binary data
 * @param  {object} dataOject, The formik data object
 * @param  {object} API_PATH, The api path
 * @return {bool}  The value
 */
export const generateFormData_util = (imageKey, imageFile, dataOject, API_PATH) => {
    const formData = new FormData();
    for (const key in dataOject) {
        if (key === imageKey) {
            if (typeof imageFile == 'object') {
                formData.append(key, imageFile);
            } else {
                formData.append(key, dataOject[key].replace(API_PATH, ''));
            }
        } else {
            formData.append(key, dataOject[key]);
        }
    }
    return formData;
}


/**
 * Check if a string is empty
 * @param  {Date} data, 
 * @return {bool}  The value
 */
export const resetDate_util = (date) => {
    return (date === '0000-00-00 00:00:00') ? new Date() : new Date(date)
}


/**
 * Check if a string is empty
 * @param  {Date} data, 
 * @return {bool}  The value
 */
export const formatDate_util = (date, pattern) => {
    try {
        return format(new Date(date), pattern)
    } catch (error) {
        return;
    }
}


/**
 * Check if a number is an even number
 * @param  {Date} value, 
 * @return {bool}  The value
 */
export const isEven_util = (value) => {
    if (value % 2 === 0)
        return true;
    else
        return false;
}


/**
 * Convert string path to array e.g items.2.product.value
 * @param  {string} path, 
 * @return {array}  The array
 */
export const stringToPath_util = (path) => {
    // If the path isn't a string or an array return an empty array
    // if (!isString(path) || isEmptyArray(path)) return [];
    if (typeof path !== 'string' || Array.isArray(path)) return [];
    // Create new array
    let output = [];
    // Split to an array with dot or whitespace notation
    path.split(/\s|\./).forEach(function (item, index) {
        // Split to an array with bracket notation
        item.split(/\[([^}])\]/g).forEach(function (key) {
            // Push to the new array
            if (key.length > 0) {
                output.push(key);
            }
        });
    });

    return output;
};


/*
export const setIn_util = (obj, path, value) => {
    obj = Object.assign({}, obj);
    // Get the path as an array
    console.log(path);
    const len = path.length;
    // changes second last key to {}
    for (let i = 0; i < len - 1; i++) {
        const elem = path[i];
        if (!obj[elem] || !Object(obj[elem])) {
            obj[elem] = {};
        }
        obj = obj[elem];
    }
    // set value to second last key
    obj[path[len - 1]] = value;
    return obj;
} */


/*!
 * Add items to an object at a specific path
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object}       obj  The object
 * @param  {String|Array} path The path to assign the value to
 * @param  {*}            val  The value to assign
 */
export const setIn_util = (obj, path, val) => {
    // Convert the path to an array if not already
    path = stringToPath_util(path);

    // Cache the path length and current spot in the object
    let length = path.length;
    let current = obj;

    // Loop through the path
    path.forEach(function (key, index) {

        // Check if the assigned key shoul be an array
        let isArray = key.slice(-2) === '[]';

        // If so, get the true key name by removing the trailing []
        key = isArray ? key.slice(0, -2) : key;

        // If the key should be an array and isn't, create an array
        if (isArray && Object.prototype.toString.call(current[key]) !== '[object Array]') {
            current[key] = [];
        }

        // If this is the last item in the loop, assign the value
        if (index === length - 1) {

            // If it's an array, push the value
            // Otherwise, assign it
            if (isArray) {
                current[key].push(val);
            } else {
                current[key] = val;
            }
        }

        // Otherwise, update the current place in the object
        else {

            // If the key doesn't exist, create it
            if (!current[key]) {
                current[key] = {};
            }

            // Update the current place in the object
            current = current[key];

        }

    });

};


/*!
 * Get an object value from a specific path
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object}       obj  The object
 * @param  {String|Array} path The path
 * @param  {*}            def  A default value to return [optional]
 * @return {*}                 The value
 */
export const getIn_util = function (obj, path, def) {
    // Get the path as an array
    path = stringToPath_util(path);

    // Cache the current object
    let current = obj;

    // For each item in the path, dig into the object
    for (var i = 0; i < path.length; i++) {
        // If the item isn't found, return the default (or null)
        if (!current[path[i]]) return def;
        // Otherwise, update the current  value
        current = current[path[i]];
    }

    return current;
};



/**
 * Filtering select input options 
 * @param  {Array} array, 
 * @param  {Array} filterList, 
 * @param  {Bool} inverse, 
 * @return {Array} The filtered array result
 */
export const optionFilter_util = (array, filterList, inverse = false) => {
    return array.filter((obj) => {
        return (inverse) ? filterList.includes(obj.value) : !filterList.includes(obj.value);
    })
}




/**
 * Validating individual fields in list items 
 * @param  {object} schema, 
 * @param  {Array} items, 
 * @param  {object} itemFields, 
 * @return {object} The filtered array result
 */
export const validateItems_util = (schema, items) => {
    let newItems = [];
    let error = false;

    //Checking to see if items list is empty
    if(isEmpty_util(items)){
        return [
            newItems,
            true,
        ];
    }
    //If item list in not empty proced with validation
    for (let index = 0; index < items.length; index++) {
        let subItem = {};
        for (const key in schema) {
            //Checking for the existense of the key 
            if (!isEmpty_util(items[index][key])) {
                //Validating the list fields with Yup
                const errorState = !schema[key].isValidSync(items[index][key]);
                //If there is an error in any of the item list fields set the error valur to true
                if (errorState) { error = true; }
                //Setting the error state
                subItem = {
                    ...subItem,
                    [key]: {
                        ...items[index][key],
                        error: errorState,
                    }
                }
            }
        }

        newItems.push({
            ...items[index],
            ...subItem,
        })
    }

    return [
        newItems,
        error,
    ];
};





/**
 * Check if a string is empty
 * @param  {String} max, The string value
 * @return {int}  The value
 */

export const getRandomInt_util = (max) => {
    return Math.floor(Math.random() * Math.floor(max));
}


/**
 * Check if a string is empty
 * @param  {String} max, The string value
 * @return {int}  The value
 */

export const evalExpression_util = (obj) => {
    try {
        return Function('"use strict";return (' + obj + ')')();
    } catch (e) {
        return 0
    }
}



/**
 * Converts a string to number for calculations. If isNaN return 0.
 * @param  {String} value A string that contains an interger and a floating-point number.
 * @return {int}  The conveted number
 */


export const castToNumber_util = (value) => {
    return isNaN(Number.parseFloat(value)) ? 0 : Number.parseFloat(value)
}


/**
 * Converts a string to number for calculations. If isNaN return 0.
 * @param  {String} value A string that contains an interger and a floating-point number.
 * @return {int}  The conveted number
 */


export const templating_util = (string, value) => {
    return string.split('{{1}}').join(value);
}


/**
 * Capitalize first letter 
 * @param  {String} string
 * @return {int}  The conveted strings
 */
 export const capitalizeFirstLetter_util = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


/**
 * Camel Case Split to words. 
 * @param  {String} string
 * @return {int}  The conveted strings
 */
 export const camelCaseSplit_util  = (string) =>  {
    return string.replace(/([a-z])([A-Z])/g, '$1 $2');
};


/**
 * Camel Case Split to words. 
 * @param  {String} string
 * @return {int}  The conveted strings
 */
 export const roundToNearest_util  = (num, decimals) =>  {
  decimals = decimals || 0;
  const p = Math.pow(10, decimals);
  const n = (num * p) * (1 + Number.EPSILON);
  return Math.round(n) / p;
 }

/**
 * Camel Case Split to words. 
 * @param  {String} string
 * @return {int}  The conveted strings
 */
 export const convertUTCToLocalDate_util  = (date) =>  {
		if (!date) {
		  return date
		}
		date = new Date(date)
		date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
		return date
};

/**
 * Camel Case Split to words. 
 * @param  {String} string
 * @return {int}  The conveted strings
 */
 export const convertLocalToUTCDate_util  = (date) =>  {
    if (!date) {
        return date
      }
      date = new Date(date)
      date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
      return date
};

/**
 * Downloading files. 
 * @param  {String} fileName
 * @param  {String} urlFile
 * @return {int}  The conveted strings
 */
 export const downloadFile_util  = (fileName, fileType, data) =>  {
    const blob = new Blob([ data ], { type: fileType });
    let urlFile = window.URL.createObjectURL(blob);

    let a = document.createElement("a");
    a.style = "display: none";
    document.body.appendChild(a);
    a.href = urlFile;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(urlFile);
    a.remove();
};
//<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
